import { connect } from 'react-redux';
import { injectIntl } from "react-intl";
import ClaimStatisticsComponent from './ClaimStatistics';
import { selectClaimAnalysisStats, selectTriageStats } from '../../../store/selectors/claimAnalysis';
import { selectRecoveredAmountFlag } from '../../../store/selectors/settings';

export const ClaimStatistics = connect(
    () => {
        return (state : any, props : any ) => ({
            getStatsPending: props.isFromTriage ? 
                state.claimAnalysis.getTriageStats.pending : 
                state.claimAnalysis.getStats.pending,

            stats: props.isFromTriage ? 
                selectTriageStats( state ): 
                selectClaimAnalysisStats( state ),
                
            recoveredAmountFlag: selectRecoveredAmountFlag( state, props )
        });
    }
)(injectIntl(ClaimStatisticsComponent));